module.exports = __webpack_public_path__ + "static/media/scenario3yar.b4a261a5.jpg";